import { useQuery } from "@tanstack/react-query";
import { getProjectsWithAssignmentsJira } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Obtiene los proyectos con asignaciones Jira (para el selector del dialog Jira).
// El parámetro `enabled` difiere la carga al abrir el dialog.
export const useProjectsWithAssignmentsJira = (enabled = true) =>
  useQuery({
    queryKey: timeEntryKeys.projectsWithAssignmentsJira(),
    queryFn: getProjectsWithAssignmentsJira,
    enabled,
  });
